<template>
  <div :class="['upload-wrapper']">
    <image-preview
        v-if="hasImage"
        :imageLoading.sync="imageLoading"
        :loading.sync="loading"
        :previewUrl="previewUrl">
    </image-preview>
  
    <upload
      v-if="!loading && !imageLoading"
      :is-edit="hasImage"
      :emptyInput="emptyInput"
      @previewImage="previewImage"
      @setUploadError="setUploadError"
      @showModal="showWarningModal"
      @uploadImage="uploadImage">
    </upload>

    <modal
        v-if="showModal"
        buttonText="OK"
        showClose
        type="warning"
        wrapperClasses="warning-modal"
        @close="showModal = false"
        @proceed="showModal = false">
      <div slot="body">
        <p>attention! in order to ensure the best image quality, images must be uploaded with a max of 5MB (file size) and in an acceptable image format which includes GIF, JPEG and PNG. </p>
      </div>
    </modal>

    <modal
        v-if="previewModal"
        buttonText="confirm image"
        :disableAction="loadingImage"
        :showActionButton="modalConfig.showActionButton"
        :showClose="modalConfig.showClose"
        wrapperClasses="image-preview-modal"
        @close="clearImage(true)"
        @proceed="previewModal = false">
      <div slot="header">
        <h3 class="sub-title">{{modalConfig.title}}</h3>
      </div>
      <div slot="body" class="image-preview-wrapper">
        <loading-icon v-if="loadingImage"></loading-icon>
        <image-preview
            v-else
            :previewUrl="previewUrl"
            showImageFooter
            wrapperClass="final-preview"
            @errorLoadingImage="setUploadError">
        </image-preview>
      </div>
    </modal>
  </div>
</template>

<script>
  import AxiosMixin from '../mixins/AxiosMixin'
  import ImagePreview from '../Shared/ImagePreview'
  import LoadingIcon from '../Shared/LoadingIcon'
  import Modal from '../Shared/Modal'
  import Upload from '../Shared/Upload'

  export default {
    props: {
      adId: Number,
      adImage: [File, Object],
      currentAdvertiserId: [Number, String],
      isEdit: Boolean,
      imageLoading: Boolean
    },

    name: 'AddImage',

    mixins: [AxiosMixin],

    components: {
      ImagePreview,
      Modal,
      LoadingIcon,
      Upload,
    },

    data() {
      return {
        defaultImageModalConfig: {
          title: 'we automatically add any regional disclaimers to the image upon send',
          showClose: true
        },
        emptyInput: null,
        hasImage: !!this.adImage,
        imageFile: null,
        loading: false,
        loadingImage: false,
        modalConfig: null,
        previewModal: null,
        previewUrl: null,
        resizedImageModalConfig: {
          title: 'optimizing image for carrier deliverability',
          showClose: false,
          showActionButton: false
        },
        showModal: false
      }
    },

    methods: {
      clearImage(isCancel) {
        this.previewModal = false
        this.imageFile = null
        this.emptyInput= true
        if (isCancel) {
          this.removeImage()
        } else {
          this.loading = false
          this.showModal = false
        }
      },

      previewImage(file, needResize) {
        this.imageFile = file
        this.modalConfig = needResize ? this.resizedImageModalConfig : this.defaultImageModalConfig
        this.loadingImage = true
        this.previewModal = true
      },

      removeImage() {
        this.loading = true
        this.imageFile = null

        this.axiosMethod({
          url: `/brands/${this.currentAdvertiserId}/brand_campaigns/${this.adId}/attachments/${this.adImage.uuid}`,
          methodType: 'delete',
          onSuccess: this.removeImageSuccessHandler,
          onError: this.removeImageErrorHandler
        })
      },

      removeImageSuccessHandler(data) {
        if (data) {
          this.$emit('loadAd')
          this.$emit('setPageErrors', 'api')
          if (this.isEdit) {
            this.previewUrl = null
            this.setImage()
          }
        
          if (!this.isEdit) {
            this.validateImage()
          }
        } else {
          this.$emit('setPageErrors', 'api', 'there was an error removing image, please refresh or contact support')
        }

        this.loading = false
      },

      removeImageErrorHandler(error) {
        this.$emit('setPageErrors', 'api', `there was an issue removing image: ${error}`)
        this.loading = false
      },

      setImage() {
        this.loadingImage = false
        this.imageFile = this.adImage
        this.previewUrl = this.adImage.resized_url
        this.modalConfig = this.defaultImageModalConfig
        this.validateImage()
      },

      setUploadError(message) {
        this.$emit('setPageErrors', 'image', message)
      },

      showWarningModal() {
        this.showModal = true
      },

      uploadImage() {
        const formData = new FormData()
        formData.append('attachment', this.imageFile)
        this.$emit('uploadImage', formData, {'Content-Type': 'multipart/form-data'})
      },

      validateImage(forUpdate) {
        const errorMessage = this.imageFile ? '' : 'must upload an image'
        if (forUpdate && this.imageFile) {
          this.uploadImage()
        }
        this.$emit('setPageErrors', 'image', errorMessage)
      },
    },

    created() {
      if (this.hasImage) { this.setImage() }
    },

    watch: {
      adImage: function () {
        this.hasImage = !!this.adImage
        this.hasImage ? this.setImage() : this.clearImage()
      },
    },
  }
</script>


<style lang="sass">
.upload-wrapper
  margin: 1rem

  &.disabled
    opacity: .25

  .gif-warning
    font-size: 1.1em
    margin-bottom: 1em

.image-preview-modal
  h3
    font-size: 1.25rem
  .button.confirm
    font-size: 1.25rem
    padding: .5rem 2rem
</style>
